// Keep in sync with Sidebar topMenuOptions. Access dashboard reads this;
// the sidebar still owns isActive / icons.

export const NAV_VIEWS = [
    { label: 'Home', to: '/', alwaysShow: true },
    {
        label: 'Javelina',
        to: '/jv',
        allowedRoles: ['jv'],
        screens: ['Clients', 'Employees', 'Claims', 'Reinsurance', 'Check Journals'],
    },
    {
        label: 'Configuration',
        to: '/config',
        allowedRoles: ['config'],
        screens: [
            'Guide', 'Audit', 'Accounts', 'Account Hierarchy', 'Account Builder', 'Account Audit',
            'Department Builder', 'Templates', 'Components', 'Network Definitions', 'Value List',
            'Provisions', 'Service Categories', 'Benefit plans', 'Plan Builder', 'Migrate',
        ],
    },
    {
        label: 'Notifications',
        to: '/notifications',
        allowedRoles: ['notifications'],
        screens: ['Outbox', 'Test Email Template'],
    },
    {
        label: 'Codes',
        to: '/codes',
        allowedRoles: ['config', 'claims'],
        screens: [
            'Services', 'Revenue', 'Drugs', 'Diagnosis', 'Procedures', 'Place of Service',
            'Type of Bill', 'Modifiers', 'Condition', 'Occurrence', 'Code Entries',
        ],
    },
    { label: 'Members', to: '/members', allowedRoles: ['members'] },
    { label: 'Coverage', to: '/coverage', allowedRoles: ['config', 'members'] },
    { label: 'Claims', to: '/claims', allowedRoles: ['claims'], screens: ['Guide', 'Search'] },
    {
        label: 'Providers',
        to: '/providers',
        allowedRoles: ['providers'],
        screens: ['Guide', 'Suppliers', 'Practitioners', 'Roles', 'Networks', 'Supplier Contracts', 'Fee Components'],
    },
    { label: 'Edi', to: '/edi', allowedRoles: ['edi'], screens: ['Ingestion', 'EDI Extract Self-Service'] },
    { label: 'Access', to: '/access', screens: ['Users', 'Roles'] },
    {
        label: 'Dynamo DB',
        to: '/dynamodb',
        allowedRoles: ['dynamodb'],
        screens: [
            'BenefitPlans', 'Business', 'ClaimAndAccumulator', 'FinanceInboundInvoices',
            'Hrp', 'Member', 'Notification', 'NotificationJobRegistry', 'PcpTransactions', 'Referral',
        ],
    },
    { label: 'Athena', to: '/athena', allowedRoles: ['dynamodb'], screens: ['service_member'] },
    { label: 'Support', to: '/support', allowedRoles: ['support'], screens: ['Tickets', 'QInConnect'] },
    { label: 'Agents', to: '/agents', allowedRoles: ['member-care', 'finance', 'admin', 'agents'] },
    { label: 'Member Care', to: '/member-care', allowedRoles: ['member-care'], screens: ['Chatbot', 'Call Summary'] },
    {
        label: 'Finance',
        to: '/finance',
        allowedRoles: ['finance'],
        screens: [
            'Guide', 'Ops', 'Bills', 'Funding', 'Payment cycles', 'Billing rates', 'Premium payments',
            'JV Check Journals', 'Billing Rate Builder', 'HRP Check Generator', 'Inbound Invoices',
        ],
    },
    { label: 'Monitoring', to: '/monitoring', allowedRoles: ['job-monitoring'], screens: ['Jobs', 'Groups', 'Cognito'] },
    { label: 'Stop Loss', to: '/stoploss', allowedRoles: ['stoploss'], screens: ['HRP Hold Report Self-Service'] },
    { label: 'Settings', to: '/settings', alwaysShow: true },
];

export function roleHasView(role, view) {
    if (view.alwaysShow) return true;
    if (role === 'admin') return true;
    return Boolean(view.allowedRoles?.includes(role));
}

export function viewsForRole(role) {
    return NAV_VIEWS.filter((view) => roleHasView(role, view));
}

export function notesForRole(role, endpoints) {
    const notes = [];
    if (role === 'admin') {
        notes.push('Admin sees every nav item and skips backend path checks.');
    }
    if (role === 'javelina') {
        notes.push('The Javelina sidebar item is gated on `jv`, not `javelina`. Users need `jv` to see the menu and `javelina` for `/jv-proxy/*`.');
    }
    if (role === 'jv') {
        notes.push('No API paths are granted to `jv`. Javelina endpoints use role `javelina`.');
    }
    if (role !== 'admin' && (!endpoints || endpoints.length === 0)) {
        notes.push('No backend path grants for this role.');
    }
    return notes;
}
